import { useContext, useEffect, useState } from "react";
import cn from "classnames";
import styles from "./PortalHeader.module.scss";
import { useNavigate } from "react-router-dom";
import NotificationIcon from "../../assets/images/portal/layout/icons/notification-icon.svg";
import UserIcon from "../../assets/images/portal/layout/icons/user-icon.svg";
import AccountSettingMenu from "../../elements/DropdownMenu/AccountSettingMenu";
import { Badge, Box, Tooltip } from "@mui/material";
import { UserDetailsContext } from "../../contexts/UserDetailsProvider";
import { CompanyDetailsContext } from "../../contexts/CompanyDetailsProvider";
import { Inbox } from "@novu/react";
import _sendAPIRequest from "../../helpers/api";

const PortalHeader = () => {
  const { userDetails } = useContext(UserDetailsContext);
  const { companyDetails } = useContext(CompanyDetailsContext);
  const [isActive, setIsActive] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [subscriberId, setSubscriberId] = useState(null);
  const open = Boolean(anchorEl);
  const novuAppID = import.meta.env.VITE_NOVU_APPLICATION_IDENTIFIER;
  const navigate = useNavigate();

  useEffect(() => {
    if (userDetails?.novu_subscriber_id) {
      setSubscriberId(userDetails.novu_subscriber_id);
    }
  }, [userDetails?.novu_subscriber_id]);

  const tabs = [
    {
      label: "All",
      filter: { tags: [] },
    },
    {
      label: "System",
      filter: { tags: ["system"] },
    },
    {
      label: "Announcements",
      filter: { tags: ["announcements"] },
    },
  ];

  const handleClick = (event) => {
    setIsActive(!isActive);
    setAnchorEl(event.currentTarget);
  };

  return (
    <header>
      <nav
        className={cn(
          "navbar",
          "navbar-expand-lg",
          "navbar-light",
          "p-0",
          styles["custom-navbar"],
        )}
      >
        <div className="container-fluid">
          <a className="navbar-brand" href="/portal">
            <img src="/logo.png" alt="logo" className={styles["logo-img"]} />
          </a>
          <div className={styles["icon-container"]}>
            {subscriberId && (
              <Inbox
                applicationIdentifier={novuAppID}
                subscriberId={subscriberId}
                subscriberHash={userDetails?.novu_subscriber_hash}
                backendUrl="https://eu.api.novu.co"
                socketUrl="https://eu.ws.novu.co"
                localization={{
                  "inbox.filters.labels.default": "Notifications",
                }}
                tabs={tabs}
                onNotificationClick={(notification) => {
                  const redirectUrl = notification?.redirect?.url;
                  if (!redirectUrl) return;
                  const current = new URL(window.location.href);
                  const target = new URL(redirectUrl, window.location.origin);

                  const isSamePath = current.pathname === target.pathname;
                  const isSameQuery = current.search === target.search;
                  if (isSamePath && isSameQuery) {
                    window.location.reload();
                    return;
                  }
                  navigate(target.pathname + target.search);
                }}
                renderBell={(unreadCount) => {
                  return (
                    <Badge
                      badgeContent={unreadCount?.total}
                      color="error"
                      overlap="circular"
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <Tooltip title={"Notification"}>
                        <img
                          src={NotificationIcon}
                          alt="Notification Icon"
                          width={32}
                          height={32}
                        />
                      </Tooltip>
                    </Badge>
                  );
                }}
              />
            )}
            <Tooltip title={companyDetails?.name}>
              {companyDetails?.logo ? (
                <Box
                  onClick={handleClick}
                  component="img"
                  className={cn("cursor", styles["company-logo"])}
                  src={companyDetails?.logo}
                  alt="Company Logo"
                />
              ) : (
                <Box className={cn("cursor")} onClick={handleClick}>
                  <img src={UserIcon} alt="User Icon" />
                </Box>
              )}
            </Tooltip>
            <AccountSettingMenu
              open={open}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              from={"Portal"}
              userDetails={userDetails}
              companyDetails={companyDetails}
            />
          </div>
        </div>
      </nav>
    </header>
  );
};

export default PortalHeader;
